var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52 1.36667C7.68 1.12222 6.72 1 5.88 1C5.28 1 4.8 1.12222 4.32 1.61111C3.96 1.97778 3.72 2.58889 3.72 3.2V3.56667H3.36C1.56 3.56667 0 5.03333 0 6.98889V19.5778C0 21.4111 1.56 23 3.36 23H12.24V3.56667C11.16 2.58889 9.84 1.85556 8.52 1.36667ZM3.36 21.1667C2.52 21.1667 1.8 20.4333 1.8 19.5778V6.98889C1.8 6.13333 2.52 5.4 3.36 5.4H3.72V17.1333C3.72 18.3556 4.68 19.2111 5.76 19.3333C6.6 19.3333 7.32 19.5778 8.04 19.8222C8.88 20.1889 9.6 20.6778 10.08 21.1667H3.36ZM20.64 3.56667H13.44V23H20.64C22.44 23 24 21.4111 24 19.5778V6.98889C24 5.03333 22.44 3.56667 20.64 3.56667ZM19.44 19.2111H15.72C15.24 19.2111 14.76 18.8444 14.76 18.2333C14.76 17.7444 15.12 17.2556 15.72 17.2556H19.44C19.92 17.2556 20.4 17.6222 20.4 18.2333C20.28 18.8444 19.92 19.2111 19.44 19.2111ZM19.44 14.2H15.72C15.24 14.2 14.76 13.8333 14.76 13.2222C14.76 12.7333 15.12 12.2444 15.72 12.2444H19.44C19.92 12.2444 20.4 12.6111 20.4 13.2222C20.28 13.7111 19.92 14.2 19.44 14.2ZM19.44 9.06667H15.72C15.24 9.06667 14.76 8.7 14.76 8.08889C14.76 7.6 15.12 7.11111 15.72 7.11111H19.44C19.92 7.11111 20.4 7.47778 20.4 8.08889C20.28 8.7 19.92 9.06667 19.44 9.06667Z",
    fill: "#959FA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.f7ec3f2647987eaea057b975c1130750.svg";
export { ForwardRef as ReactComponent };